import { computed, onUnmounted, ref } from 'vue';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';
import { equals, isEmpty, path, propOr } from 'ramda';
import { useGlobalState } from "@/store/user.store.js";

const fetchSubscription = (endpoint) => {
  const { callEndpoint, endpointData, isLoading } = useCallEndPointWith(endpoint);
  const { currentSubscription } = useGlobalState();

  const fetch = async () => {
    await callEndpoint({ method: 'GET' }).then((response) => {
      if (!isEmpty(response)) {
        const expire = propOr(Date.now() + 1000 * 60 * 60, 'expireCacheTimestamp', response);
        currentSubscription.set(response, expire);
      }
    });
  };

  const response = computed(() => endpointData.value);

  return { fetch, response, isLoading };
};

export default fetchSubscription;

export const isSubscriptionActive = (subscription) => equals('ACTIVE', path(['status'], subscription));
export const isSubscriptionExpired = (subscription) => equals('EXPIRED', path(['status'], subscription));

export function useSubscriptionPolling(
    paymentSuccess,
    endpoint,
    pollInterval = 5000,
) {
  const subscriptionAPI = fetchSubscription(endpoint);
  const subscriptionStatus = ref(null);
  const isSubscriptionActiveComputed = computed(() => subscriptionStatus.value === 'ACTIVE');

  let intervalId = null;
  let timeoutId = null;
  const maxPollingTime = 300000;

  const pollSubscription = () => {
    subscriptionAPI.fetch().then(() => {
      const data = subscriptionAPI.response.value;
      if (data && data.status) {
        subscriptionStatus.value = data.status;
        if (data.status === 'ACTIVE' && intervalId) {
          clearInterval(intervalId);
        }
      }
    });
  };

  if (paymentSuccess) {
    pollSubscription();
    intervalId = setInterval(pollSubscription, pollInterval);
    timeoutId = setTimeout(() => {
      if (intervalId) clearInterval(intervalId);
    }, maxPollingTime);
  }

  onUnmounted(() => {
    if (intervalId) clearInterval(intervalId);
    if (timeoutId) clearTimeout(timeoutId);
  });

  return {
    subscriptionStatus,
    isSubscriptionActive: isSubscriptionActiveComputed,
  };
}
